import React, { useState } from 'react';
import Icon from '../AppIcon';
import Button from './Button';

const Header = ({ className = '' }) => {
  const [isMobileMenuOpen, setIsMobileMenuOpen] = useState(false);
  const [isMoreMenuOpen, setIsMoreMenuOpen] = useState(false);

  const primaryNavItems = [
    { label: 'Search', path: '/crane-search-dashboard', icon: 'Search' },
    { label: 'Compare', path: '/comparison-tool', icon: 'GitCompare' },
    { label: 'Manage', path: '/inventory-management', icon: 'Package' },
    { label: 'Portfolio', path: '/portfolio-dashboard', icon: 'BarChart3' },
  ];

  const secondaryNavItems = [
    { label: 'Account Settings', path: '/account-settings', icon: 'Settings' },
    { label: 'Admin Panel', path: '/admin-panel', icon: 'Shield' },
  ];

  const toggleMobileMenu = () => {
    setIsMobileMenuOpen(!isMobileMenuOpen);
  };

  const toggleMoreMenu = () => {
    setIsMoreMenuOpen(!isMoreMenuOpen);
  };

  const handleNavClick = (path) => {
    window.location.href = path;
    setIsMobileMenuOpen(false);
    setIsMoreMenuOpen(false);
  };

  return (
    <header className={`sticky top-0 z-100 bg-surface border-b border-border shadow-card ${className}`}>
      <div className="w-full px-6 py-4">
        <div className="flex items-center justify-between">
          {/* Logo */}
          <div className="flex items-center">
            <button 
              onClick={() => handleNavClick('/crane-search-dashboard')}
              className="flex items-center space-x-3 transition-smooth hover:opacity-80"
            >
              <div className="w-8 h-8 bg-primary rounded-lg flex items-center justify-center">
                <Icon name="Crane" size={20} color="white" />
              </div>
              <span className="text-xl font-semibold text-text-primary">CranePrice</span>
            </button>
          </div>

          {/* Desktop Navigation */}
          <nav className="hidden lg:flex items-center space-x-8">
            {primaryNavItems?.map((item) => (
              <button
                key={item?.path}
                onClick={() => handleNavClick(item?.path)}
                className="flex items-center space-x-2 px-3 py-2 text-sm font-medium text-text-secondary hover:text-primary transition-smooth rounded-md hover:bg-muted"
              >
                <Icon name={item?.icon} size={16} />
                <span>{item?.label}</span>
              </button>
            ))}
            
            {/* More Menu */}
            <div className="relative">
              <Button
                variant="ghost"
                size="sm"
                onClick={toggleMoreMenu}
                iconName="MoreHorizontal"
                iconPosition="right"
                className="text-text-secondary hover:text-primary"
              >
                More
              </Button>
              
              {isMoreMenuOpen && (
                <div className="absolute right-0 mt-2 w-48 bg-popover border border-border rounded-md shadow-dropdown z-300">
                  <div className="py-1">
                    {secondaryNavItems?.map((item) => (
                      <button
                        key={item?.path}
                        onClick={() => handleNavClick(item?.path)}
                        className="flex items-center space-x-2 w-full px-4 py-2 text-sm text-text-secondary hover:text-primary hover:bg-muted transition-smooth"
                      >
                        <Icon name={item?.icon} size={16} />
                        <span>{item?.label}</span>
                      </button>
                    ))}
                  </div>
                </div>
              )}
            </div>
          </nav>

          {/* User Actions */}
          <div className="hidden lg:flex items-center space-x-4">
            {/* Subscription Tier Indicator */}
            <div className="flex items-center space-x-2 px-3 py-1 bg-muted rounded-full">
              <div className="w-2 h-2 bg-success rounded-full"></div>
              <span className="text-xs font-medium text-text-secondary">Pro</span>
            </div>
            
            {/* User Menu */}
            <Button
              variant="ghost"
              size="sm"
              iconName="User"
              className="text-text-secondary hover:text-primary"
            >
              Profile
            </Button>
          </div>

          {/* Mobile Menu Button */}
          <Button
            variant="ghost"
            size="sm"
            onClick={toggleMobileMenu}
            iconName={isMobileMenuOpen ? "X" : "Menu"}
            className="lg:hidden text-text-secondary hover:text-primary"
          />
        </div>

        {/* Mobile Navigation */}
        {isMobileMenuOpen && (
          <div className="lg:hidden mt-4 pb-4 border-t border-border">
            <nav className="flex flex-col space-y-2 mt-4">
              {primaryNavItems?.map((item) => (
                <button
                  key={item?.path}
                  onClick={() => handleNavClick(item?.path)}
                  className="flex items-center space-x-3 px-3 py-3 text-sm font-medium text-text-secondary hover:text-primary hover:bg-muted transition-smooth rounded-md"
                >
                  <Icon name={item?.icon} size={18} />
                  <span>{item?.label}</span>
                </button>
              ))}
              
              <div className="border-t border-border my-2"></div>
              
              {secondaryNavItems?.map((item) => (
                <button
                  key={item?.path}
                  onClick={() => handleNavClick(item?.path)}
                  className="flex items-center space-x-3 px-3 py-3 text-sm font-medium text-text-secondary hover:text-primary hover:bg-muted transition-smooth rounded-md"
                >
                  <Icon name={item?.icon} size={18} />
                  <span>{item?.label}</span>
                </button>
              ))}
              
              <div className="border-t border-border my-2"></div>
              
              {/* Mobile User Actions */}
              <div className="flex items-center justify-between px-3 py-3">
                <div className="flex items-center space-x-2">
                  <div className="w-2 h-2 bg-success rounded-full"></div>
                  <span className="text-sm font-medium text-text-secondary">Pro Subscription</span>
                </div>
                <Button
                  variant="ghost"
                  size="sm"
                  iconName="User"
                  className="text-text-secondary hover:text-primary"
                />
              </div>
            </nav>
          </div>
        )}
      </div>
      {/* Overlay for mobile menu */}
      {isMobileMenuOpen && (
        <div 
          className="fixed inset-0 bg-black bg-opacity-25 z-50 lg:hidden"
          onClick={() => setIsMobileMenuOpen(false)}
        />
      )}
      {/* Overlay for more menu */}
      {isMoreMenuOpen && (
        <div 
          className="fixed inset-0 z-200"
          onClick={() => setIsMoreMenuOpen(false)}
        />
      )}
    </header>
  );
};

export default Header;